// extracted by mini-css-extract-plugin
export default {"input":"Input_input__+8sMB","mono":"Input_mono__BqF5e","invalid":"Input_invalid__iqqRN"};